import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, withKeys as _withKeys, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a5d3c0ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "searchBox" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-onetabarrow-down" }, null, -1))
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "text" }

import { RaInput, RaMessage } from '@rafter/pc';
import { searchEngines } from '@/store/searchEngines';
import { ref, onMounted, onBeforeUnmount, toRef } from 'vue';
import SearchList from '@/components/SearchList';
import { getData, getParamsUrl } from '../utils/index';
import axios from 'axios';
import { settings } from '@/store/settings';
import { requestProxy } from '@/api/baseApi';

export default /*#__PURE__*/_defineComponent({
  __name: 'SearchComponent',
  setup(__props) {

const isShow = ref(false);
const listShow = ref(false);
const listRef = ref();
const targetElementRef = toRef(listRef);

const checkedItem = ref({
  name: '百度',
  url: 'https://www.baidu.com/s?wd=',
  icon: require('../background/baidu_icon.png'),
  isActive: true,
});
const searchList = ref([]);
const getSearchList = (value: string) => {
  if (!value) {
    listShow.value = false;
    searchList.value = [];
    return;
  }
  requestProxy({
    url: `https://suggestion.baidu.com/su?p=3&ie=UTF-8&cb=&wd=${value}`,
  }).then((res) => {
    console.log(res);
    if (res.data.code === 200) {
      const data = JSON.parse(convertToJSON(res.data.data));

      if (data.s?.length) {
        console.log(data.s);
        listShow.value = true;
        searchList.value = data.s;
      }
    }
  });
};
const convertToJSON = (text: string) => {
  // 去除开头的 window.baidu.sug( 和末尾的 );
  text = text.replace('(', '');
  text = text.replace(');', '');

  // 将属性名添加双引号
  text = text.replace(/([{,]\s*)([a-zA-Z0-9_]+?)\s*:/g, '$1"$2":');

  // 将单引号替换为双引号
  text = text.replace(/'/g, '"');
  text = text.replace(/"p":,/g, '"p":null,');
  // 返回标准的 JSON 字符串
  return text;
};
const inputValue = ref('');
const changeSearchEngines = (e) => {
  e.stopPropagation();
  listShow.value = false;
  isShow.value = !isShow.value;
};
const onChange = (value: any) => {
  getSearchList(value);
};
const onBlur = () => {
  listShow.value = false;
};
const onFocus = () => {
  if (searchList.value.length) {
    listShow.value = true;
  }
};
const changeEnginer = (item) => {
  searchEngines.setActive({ ...item, isActive: true });
  isShow.value = false;
  checkedItem.value = item;
};
const handleClickOutside = (event) => {
  if (listRef.value && !listRef.value.contains(event.target)) {
    if (isShow.value) {
      isShow.value = false;
    }
  }
};
onMounted(() => {
  document.addEventListener('click', handleClickOutside);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(RaInput), {
      class: "searchinput",
      type: "text",
      modelValue: inputValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
      placeholder: "请输入搜索内容",
      onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_unref(searchEngines).goSearch(inputValue.value)), ["enter"])),
      onInput: onChange,
      onFocus: onFocus
    }, {
      prepend: _withCtx(() => [
        _createElementVNode("div", {
          class: "logo",
          onClick: changeSearchEngines
        }, [
          _createElementVNode("div", {
            style: _normalizeStyle({ backgroundImage: `url(${checkedItem.value.icon})` })
          }, null, 4),
          _hoisted_2
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_Transition, { name: "sl-fade" }, {
      default: _withCtx(() => [
        (isShow.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "search-list",
              ref_key: "listRef",
              ref: listRef
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(settings).searchEngines, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item,
                  onClick: ($event: any) => (
            changeEnginer(_unref(searchEngines).list.find((s) => s.value === item))
          )
                }, [
                  _createElementVNode("img", {
                    class: "item",
                    src: _unref(searchEngines).list.find((s) => s.value === item)?.icon,
                    alt: ""
                  }, null, 8, _hoisted_4),
                  _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(searchEngines).list.find((s) => s.value === item)?.name), 1)
                ], 8, _hoisted_3))
              }), 128))
            ], 512))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (listShow.value)
      ? (_openBlock(), _createBlock(_unref(SearchList), {
          key: 0,
          class: "list",
          list: searchList.value,
          searchEngine: checkedItem.value,
          onBlur: onBlur,
          "search-key": inputValue.value
        }, null, 8, ["list", "searchEngine", "search-key"]))
      : _createCommentVNode("", true)
  ]))
}
}

})